// extracted by mini-css-extract-plugin
export default {"canvasRightComFill":"canvasRightComFill_canvasRightComFill__C1uU2","sizeTips":"canvasRightComFill_sizeTips__J-LHx"};